import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  toast: {
    display: "flex",
    alignItems: "stretch",
    width: 360,
    maxWidth: "calc(100vw - 32px)",
    backgroundColor: theme.design.color.surface.container,
    border: `1px solid ${theme.design.color.border.default}`,
    borderRadius: theme.design.radius.lg,
    boxShadow: theme.design.shadow.toast,
    overflow: "hidden",
    pointerEvents: "auto",
    opacity: 0,
    transform: "translate3d(0, -10px, 0)",
    transition:
      "opacity 0.35s cubic-bezier(.21,1.02,.73,1), transform 0.35s cubic-bezier(.21,1.02,.73,1)",
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  },

  entered: {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },

  leaving: {
    opacity: 0,
    transform: "translate3d(0, -10px, 0)",
    transition:
      "opacity 0.28s cubic-bezier(.06,.71,.55,1), transform 0.28s cubic-bezier(.06,.71,.55,1)",
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  },

  rail: {
    width: 4,
    flexShrink: 0,
  },

  successRail: {
    backgroundColor: theme.design.color.action.primary,
  },

  infoRail: {
    backgroundColor: theme.design.color.status.warning,
  },

  errorRail: {
    backgroundColor: theme.design.color.status.danger,
  },

  body: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.xs,
    padding: "12px 8px 12px 14px",
  },

  stamp: {
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    lineHeight: 1,
  },

  successStamp: {
    color: theme.design.color.action.primary,
  },

  infoStamp: {
    color: theme.design.color.status.warning,
  },

  errorStamp: {
    color: theme.design.color.status.danger,
  },

  message: {
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    color: theme.design.color.text.primary,
    lineHeight: 1.4,
    wordBreak: "break-word",
  },

  detail: {
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 11,
    color: theme.design.color.text.muted,
    letterSpacing: "0.02em",
  },

  close: {
    alignSelf: "flex-start",
    color: theme.design.color.text.muted,
    padding: theme.design.space.sm,
    margin: theme.design.space.xs,
    "&:hover": {
      color: theme.design.color.text.primary,
      backgroundColor: theme.design.color.overlay.white10,
    },
    "& svg": {
      width: theme.design.size.icon.sm,
      height: theme.design.size.icon.sm,
    },
  },
}));
